@let currentLabel = label();

<div class="mb-2 relative {{ label() ? 'mt-[25px]' : '' }}">
  <!-- Label flotante -->
  <label
    [id]="effectiveName + '-label'"
    [for]="effectiveName + '-button'"
    class="absolute left-3 px-2 text-[14px] font-medium bg-white z-11 break-words transition-all duration-200 ease-in-out"
    [ngClass]="{
      'top-2': (!_value || _value.length === 0) && !isDisabled && !isDropdownOpen,
      '-top-6': isDisabled || (_value && _value.length > 0 && !isDropdownOpen),
      '-top-2.5 rounded-t-md': isDropdownOpen,
      'text-gray-700': !isDisabled && !isDropdownOpen && !isInvalid,
      'text-gray-500': isDisabled,
      'text-primary-500': !isDisabled && isDropdownOpen && !isInvalid,
      'text-red-500': isInvalid && displayError(),
    }"
  >
    {{ currentLabel | translate }}
  </label>
  <div class="relative">
    <button
      type="button"
      [name]="effectiveName"
      [id]="effectiveName + '-button'"
      (click)="toggleDropdown()"
      class="block w-full px-3 py-2 text-left border rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-[14px] transition-colors duration-200 hover:border-blue-500 pr-10"
      aria-haspopup="listbox"
      [attr.aria-expanded]="isDropdownOpen"
      [disabled]="isDisabled"
      [ngClass]="{
        'border-red-500': isInvalid && displayError(),
        'text-red-900': isInvalid && displayError(),
        'border-green-500':
          ngControl && ngControl.valid && (ngControl.touched || ngControl.dirty) && displayError(),
        'border-gray-300':
          !isInvalid && !(ngControl && ngControl.valid && (ngControl.touched || ngControl.dirty)),
        'focus:border-blue-600': !isInvalid,
        'focus:ring-blue-600': !isInvalid,
        'bg-gray-200': isDisabled,
        'cursor-not-allowed': isDisabled,
        'text-gray-500': isDisabled,
      }"
    >
      <span
        class="block truncate min-h-[1.25rem]"
        [ngClass]="{
          'text-red-600': isInvalid,
          'text-gray-500': !isInvalid && (!_value || _value.length === 0),
        }"
      >
        {{
          _value && _value.length > 0
            ? displayText
            : ((isDropdownOpen ? effectivePlaceholder : '') | translate)
        }}
      </span>
      <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        <svg
          class="h-5 w-5 text-gray-400"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M10 3a.75.75 0 01.53.22l3.5 3.5a.75.75 0 01-1.06 1.06L10 4.81 6.53 8.28a.75.75 0 01-1.06-1.06l3.5-3.5A.75.75 0 0110 3zm-3.72 9.53a.75.75 0 011.06 0L10 15.19l3.22-3.22a.75.75 0 111.06 1.06l-3.5 3.5a.75.75 0 01-1.06 0l-3.5-3.5a.75.75 0 010-1.06z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </button>
  </div>

  @if (displayError()) {
    <lib-custom-error-display [errors]="errors()" [control]="ngControl"></lib-custom-error-display>
  }
</div>

<ng-template #dropdownTemplate>
  <div
    class="w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-[14px]"
  >
    <ul tabindex="-1" role="listbox" [attr.aria-labelledby]="effectiveName + '-label'" class="py-1">
      @for (option of options(); track option.value; let i = $index) {
        <li
          class="text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9 hover:bg-indigo-600 hover:text-white"
        >
          <label class="flex items-center w-full h-full cursor-pointer">
            <input
              type="checkbox"
              [name]="effectiveName + '-' + option.value"
              [id]="effectiveName + '-' + option.value + '-' + i"
              [checked]="isOptionSelected(option.value)"
              (change)="onOptionChange(option.value, $event)"
              [disabled]="isDisabled"
              class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 mr-3 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
            />
            <span class="block truncate font-normal">
              {{ option.display | translate }}
            </span>
          </label>
        </li>
      }
      @if (options().length === 0) {
        <li class="text-gray-500 cursor-default select-none relative py-2 px-4">
          No hay opciones disponibles.
        </li>
      }
    </ul>
  </div>
</ng-template>
